import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Quick Match queue size, and coin offers waiting for one ranked duel.
 * The queue comes from the chat socket. The offer comes from the account.
 */
export const useRankedLobbyStore = defineStore('rankedLobby', () => {
  const waiting = ref<number | null>(null)
  const casualWaiting = ref<number | null>(null)
  const eventWaiting = ref<number | null>(null)
  const closed = ref(false)
  const offerPending = ref(0)
  const callClaims = ref(0)

  function setWaiting(
    count: number | null,
    queueClosed = false,
    casual = 0,
    event = 0,
  ): void {
    if (count === null) {
      waiting.value = null
      casualWaiting.value = null
      eventWaiting.value = null
      closed.value = false
      return
    }
    waiting.value = Math.max(0, Math.trunc(count))
    casualWaiting.value = Math.max(0, Math.trunc(casual))
    eventWaiting.value = Math.max(0, Math.trunc(event))
    closed.value = queueClosed
  }

  function setOfferPending(count: number): void {
    offerPending.value = Math.max(0, Math.trunc(count))
  }

  function setCallClaims(count: number): void {
    callClaims.value = Math.max(0, Math.trunc(count))
  }

  function clear(): void {
    waiting.value = null
    casualWaiting.value = null
    eventWaiting.value = null
    closed.value = false
    offerPending.value = 0
    callClaims.value = 0
  }

  return {
    waiting,
    casualWaiting,
    eventWaiting,
    closed,
    offerPending,
    callClaims,
    setWaiting,
    setOfferPending,
    setCallClaims,
    clear,
  }
})
